/**
 * Фича-флаги разделов панели — зеркало `deeproller-back/src/config/features.ts`.
 *
 * На первом этапе «Друзьям DeepRoller» нужен только промо-контур: промокоды,
 * заказы/продажи с аналитикой, заявки рефералов и служебные разделы. Остальное
 * (разделы AmoCRM, чаты, боты, ИИ) не удалено, а выключено: страницы, роуты и
 * компоненты остаются в репозитории. Вернуть раздел = поставить `true` здесь И
 * в файле бэка (иначе интерфейс появится, а API будет отвечать 404).
 */
export const FEATURES = {
  /** Промокоды: управление, обзор программы, дыры атрибуции, проверка кода */
  codes: true,
  /** Панель заказов и аналитика продаж */
  orders: true,
  /** Заявки рефералов */
  leads: true,
  /** Управление пользователями панели и журнал безопасности */
  users: true,
  /** Раздел «Настройки» целиком */
  settings: true,
  /** Настройки → вкладка AmoCRM (привязка интеграции) */
  settings_amo: true,

  /** Разделы AmoCRM: приём сделок, дубли, звонки, сверка этапов, поиск сделок */
  amo: false,
  /** Чаты с клиентами по виджетам сайта */
  chats: false,
  /** Настройки → вкладка «Боты» (Telegram/VK и воронки) */
  bots: false,
  /** Настройки → вкладки ИИ: провайдеры, агенты, сниппеты */
  ai: false,
};

/** Включён ли раздел. Неизвестный ключ считается включённым — гейтим только перечисленное. */
export const isEnabled = (key) => FEATURES[key] !== false;

/**
 * Ключ раздела прав (permissionKey плиток и PERMISSION_SECTIONS) → флаг.
 * Совпадает с картой SECTION_FEATURE на бэке.
 */
const SECTION_FEATURE = {
  codes: 'codes',
  promo: 'codes',
  promo_overview: 'codes',
  attribution_gaps: 'codes',
  orders: 'orders',
  leads: 'leads',
  users: 'users',
  settings: 'settings',
  amo_rules: 'amo',
  amo_reconcile: 'amo',
  calls: 'amo',
  chats: 'chats',
};

/** Показывать ли раздел с таким ключом прав. */
export const isSectionEnabled = (sectionKey) => {
  const feature = SECTION_FEATURE[sectionKey];
  return feature === undefined ? true : isEnabled(feature);
};

/** Вкладки страницы «Настройки» → флаг ('theme' не гейтится — это переключатель оформления). */
const SETTINGS_TAB_FEATURE = {
  amo: 'settings_amo',
  bots: 'bots',
  ai: 'ai',
  agents: 'ai',
};

/** Показывать ли вкладку настроек. */
export const isSettingsTabEnabled = (tabKey) => {
  const feature = SETTINGS_TAB_FEATURE[tabKey];
  return feature === undefined ? true : isEnabled(feature);
};
